module.exports = __webpack_public_path__ + "static/media/DeleteTrashIcon.e5290db7.svg";